
<nav class="navbar navbar-expand-md fixed-top shadow bg-white">
  <button class="navbar-toggler border" data-toggle="collapse" data-target="#collapse_target">
    <span class="navbar-toggler-icon"><i class="fas fa-bars mt"></i></span>
  </button>
  <div class="container">
    <div class="collapse navbar-collapse" id="collapse_target">
      <div class="row w-100">
        <div class="col-md-3"><a href="/"><img src="../assets/images/logo.png" class="img-logo" /></a></div>
        <div class="col-md-8 offset-md-1 text-right">
          <ul class="navbar-nav mt-3">
            <li class="nav-item mr-2"><a class="nav-link" href="/">หน้าแรก</a></li>
            <li class="nav-item mr-2"><a class="nav-link" href="#promotion">โปรโมชั่น</a></li>
            <li class="nav-item mr-2"><a class="nav-link" href="#gallery">รูปภาพ</a></li>
            <li class="nav-item mr-2"><a class="nav-link" href="#location">สถานที่ตั้ง</a></li>
            <li class="nav-item mr-2"><a class="nav-link" href="#contact">ติดต่อเรา</a></li>
            <li class="nav-item mr-2"><a class="nav-link btn-call" href="tel:053114858"><i class="fas fa-phone-alt"></i> 053-114858</a></li>
            <li class="mr-1">
              <a target="_blank" href="https://www.facebook.com/Quick-Lane-%E0%B9%80%E0%B8%8A%E0%B8%B5%E0%B8%A2%E0%B8%87%E0%B9%83%E0%B8%AB%E0%B8%A1%E0%B9%88-%E0%B8%A8%E0%B8%B9%E0%B8%99%E0%B8%A2%E0%B9%8C%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A2%E0%B8%B2%E0%B8%87%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%A3%E0%B8%96%E0%B8%A2%E0%B8%99%E0%B8%95%E0%B9%8C-103923214565115/">
                <img src="../assets/images/Icon awesome-facebook.png" class="img-social" /></a></li>
            <li class="w-5 mr-1"><a href="https://lin.ee/mWfL07H" target="_blank"><img src="../assets/images/Icon awesome-line.png" class="img-social" /></a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nav>

<section class="main" id="top">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h4>WELCOME TO</h4>
        <img src="../assets/images/Group 436.png" class="w-100" />
        <h3>CHIANG MAI</h3>
      </div>
      <div class="col-md-6"></div>
    </div>
  </div>
</section>

<section id="promotion" class="promotion">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="swiper-container" swiper="config">
          <div class="swiper-wrapper">
            <div class="swiper-slide"><img src="../assets/images/Quicklane AirJPG.png" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/covid cnx.png" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/Quicklane ออย.png" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/Quicklane ยางง.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/ถ่ายน้ำมัน877.jpg" class="w-100" /></div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="service1" class="service1">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <h2>BEST</h2>
        <h1>SERVICES</h1>
        <h5>เมื่อรถยนต์ของท่านถึงระยะซ่อมบำรุง ควิกเลน พร้อมดูแลรถยนต์ของท่านสำหรับ 14 กลุ่มสินค้า และบริการที่มีมาตรฐานโดยช่างเทคนิคผู้เชี่ยวชาญ</h5>
      </div>
      <div class="col-md-6 offset-md-6">
        <div class="row mt">
          <div class="col-md-3 col-sm-3 col-3"><img src="../assets/images/Group 422.png" /></div>
          <div class="col-md-9 col-sm-9 col-9">
            <h6>ฟรี ตรวจเช็คสภาพรถ</h6>
            <p>ที่ควิกเลน เรามีบริการตรวจเช็คสภาพรถยนต์เบื้องต้นให้คุณ ฟรี !!</p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-3 col-sm-3 col-3"><img src="../assets/images/Group 405.png" /></div>
          <div class="col-md-9 col-sm-9 col-9">
            <h6>ระบบไฟส่องสว่าง</h6>
            <p>การตรวจสอบการทำงานของไฟหน้าและไฟหลังให้ทำงานตาม ปกติเป็นสิ่งสำคัญ เพราะการมองเห็นถนนข้างหน้าได้อย่าง ชัดเจนในเวลากลางคืน</p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-3 col-sm-3 col-3"><img src="../assets/images/Group 404.png" /></div>
          <div class="col-md-9 col-sm-9 col-9">
            <h6>ระบบชาร์จไฟและระบบไฟฟ้า</h6>
            <p>เพื่อให้มั่นใจว่าระบบไฟฟ้าของรถคุณทำงานอย่างเต็ม ประสิทธิภาพ แวะมาที่ควิกเลนสาขาใกล้บ้าน เพื่อรับบริการ ตรวจสอบไดชาร์จฟรี</p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-3 col-sm-3 col-3"><img src="../assets/images/Group 408.png" /></div>
          <div class="col-md-9 col-sm-9 col-9">
            <h6>สายพาน</h6>
            <p>สายพานที่ชำรุดหรือเสื่อมสภาพ เป็นหนึ่งในสาเหตุหลักที่ทำให้ รถยนต์ทำงานผิดปกติ</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="service2" class="service2">
  <div class="container">
    <div class="row">
      <div class="col-md-6 text-right">
        <div class="row">
          <div class="col-md-9 col-sm-9 col-9">
            <h6>ระบบปรับอากาศ</h6>
            <p>เราแนะนำให้ตรวจสอบและเติมน้ำยาแอร์ทุกๆ 2 ปี เพื่อการทำ งานอย่างเต็มประสิทธิภาพ</p>
          </div>
          <div class="col-md-3 col-sm-3 col-3"><img src="../assets/images/Group 403.png" /></div>
        </div>
        <div class="row mt-3">
          <div class="col-md-9 col-sm-9 col-9">
            <h6>สายพาน</h6>
            <p>สายพานที่ชำรุดหรือเสื่อมสภาพ เป็นหนึ่งในสาเหตุหลักที่ทำให้ รถยนต์ทำงานผิดปกติ</p>
          </div>
          <div class="col-md-3 col-sm-3 col-3"><img src="../assets/images/Group 401.png" /></div>
        </div>
        <div class="row mt-3">
          <div class="col-md-9 col-sm-9 col-9">
            <h6>เบรค</h6>
            <p>การหมั่นตรวจสภาพเบรคเป็นประจำเป็นสิ่งที่สำคัญ ที่ควิกเลน เราพร้อมให้บริการตรวจสภาพระบบเบรคโดยไม่มีค่าใช้จ่าย</p>
          </div>
          <div class="col-md-3 col-sm-3 col-3"><img src="../assets/images/Group 414.png" /></div>
        </div>
        <div class="row mt-3">
          <div class="col-md-9 col-sm-9 col-9">
            <h6>ระบบหล่อเย็น</h6>
            <p>อากาศร้อนอาจส่งผลเสียต่อรถของคุณ ทำให้ระบบหล่อเย็นทำ งานบกพร่อง และเครื่องยนต์เกิดความร้อนสูงกว่าปกติ สร้าง ความเสียหายให้กับหม้อน้ำได้</p>
          </div>
          <div class="col-md-3 col-sm-3 col-3"><img src="../assets/images/Group 402.png" /></div>
        </div>
      </div>
      <div class="col-md-6"><img src="../assets/images/16_FRD_2.png" class="w-100 mt" /></div>
    </div>
  </div>
</section>

<section id="service3" class="service3">
  <div class="container">
    <div class="row text-center">
      <div class="col-md-4">
        <img src="../assets/images/Group 425.png" />
        <h6>แบตเตอรี่</h6>
        <p>แบตเตอรี่ที่เก่าและเสื่อมสภาพอาจสร้างปัญหาให้คุณได้ คุณ สามารถตรวจสภาพแบตเตอรี่โดยไม่ต้องนัดหมายล่วงหน้าที่ ควิกเลน</p>
      </div>
      <div class="col-md-4">
        <img src="../assets/images/Group 423.png" />
        <h6>ปัดน้ำฝน</h6>
        <p>ใบปัดน้ำฝนเป็นสิ่งจำเป็นต่อการขับขี่ เพราะวิสัยทัศน์ที่เด่น ชัดในการขับรถเป็นสิ่งสำคัญต่อความปลอดภัย</p>
      </div>
      <div class="col-md-4">
        <img src="../assets/images/Group 424.png" />
        <h6>ช่วงล่างและระบบบังคับเลี้ยว</h6>
        <p>นอกจากเรื่องการขับขี่ที่นุ่มนวลแล้ว ส่วนประกอบของช่วง ล่างรถยนต์ยังมีผลต่อเสถียรภาพในการขับขี่</p>
      </div>
      <div class="col-md-4">
        <img src="../assets/images/Group 435.png" />
        <h6>ตั้งศูนย์ล้อ</h6>
        <p>เราขอแนะนำให้คุณสลับล้อและ ถ่วงล้อทั้งสี่อย่างน้อยๆทุกๆ 10,000 กิโลเมตร เพื่อช่วยยืดอายุการใช้งานของยางให้ยาว นานมากขึ้น</p>
      </div>
      <div class="col-md-4">
        <img src="../assets/images/Group 434.png" />
        <h6>น้ำมันหล่อลื่นและอะไหล่เช็คระยะ</h6>
        <p>แม้ว่าคุณจะใช้รถในระยะทางวิ่งน้อย แต่ก็ควรนำรถเข้ารับ การเปลี่ยนถ่ายน้ำมันเครื่องและตรวจเช็คระยะอย่างน้อยปี ละ 2 ครั้ง</p>
      </div>
      <div class="col-md-4">
        <img src="../assets/images/Group 433.png" />
        <h6>ยาง</h6>
        <p>หากคุณกำลังมองหาข้อเสนอดีๆในการเปลี่ยนยาง ตรวจ สอบสภาพยาง ที่ควิกเลนพร้อมดูแลเรื่องสภาพยางเพื่อ ความปลอดภัยในการขับขี่บนท้องถนน</p>
      </div>
    </div>
  </div>
</section>

<section id="service4" class="service4">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <img src="../assets/images/Group 436.png" class="w-100" />
        <h6>ควิกเลน พร้อมให้บริการรถยนต์ทุกรุ่นด้วยเทคโนโลยี ทันสมัย ให้คุณได้ <strong>อุ่นใจ ไร้กังวล</strong></h6>
      </div>
    </div>
  </div>
</section>

<section id="gallery" class="gallery">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <h2>OUR</h2>
        <h1>GALLERY</h1>
        <h5>พร้อมให้ความช่วยเหลืออย่างต่อเนื่องจากทีมงานที่มีประสบการณ์</h5>
      </div>
      <div class="col-md-12">
        <div  class="swiper-container" swiper="config">
          <div class="swiper-wrapper">
            <div class="swiper-slide"><img src="../assets/images/5602.png" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/9085.png" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/9089.png" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/5600.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/5601.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/5602.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/5604.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/5605.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9075.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9076.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9077.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9078.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9079.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9080.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9081.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9082.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9083.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9084.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9085.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9086.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9087.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9088.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9089.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9090.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/9091.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/349396.jpg" class="w-100" /></div>
            <div class="swiper-slide"><img src="../assets/images/gellary/363746.jpg" class="w-100" /></div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="location" class="location">
  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1588.040317777818!2d99.0219823822724!3d18.797364986000524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30da25822eaecbfd%3A0x55df71ca5724b065!2zUXVpY2vigIsgTGFuZeKAiyBDaGlhbmfigIsgTWFp4oCLIOC4qOC4ueC4meC4ouC5jOC4muC4o-C4tOC4geC4suC4o-C4ouC4suC4h-C5geC4peC4sOC4o-C4luC4ouC4meC4leC5jA!5e0!3m2!1sth!2sth!4v1587978313257!5m2!1sth!2sth"
  class="map" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
</section>

<section id="contact" class="contact">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <h2>OUR</h2>
        <h1>CONTACTS</h1>
        <h5>50 หมู่ 4 หนองป่าครั่ง อำเภอเมือง จังหวัดเชียงใหม่ 50000</h5>
        <h3>053-114858<br/>065-4199153</h3>
        <a target="_blank" href="https://www.facebook.com/Quick-Lane-%E0%B9%80%E0%B8%8A%E0%B8%B5%E0%B8%A2%E0%B8%87%E0%B9%83%E0%B8%AB%E0%B8%A1%E0%B9%88-%E0%B8%A8%E0%B8%B9%E0%B8%99%E0%B8%A2%E0%B9%8C%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A2%E0%B8%B2%E0%B8%87%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%A3%E0%B8%96%E0%B8%A2%E0%B8%99%E0%B8%95%E0%B9%8C-103923214565115/">
          <img src="../assets/images/Icon simple-facebook.png" />
        </a>
        <a target="_blank" href="https://lin.ee/mWfL07H"><img src="../assets/images/Icon simple-line.png" /></a>
        <p>© 2020 QUICK LANE. ALL RIGHTS RESERVED.</p>
      </div>
    </div>
  </div>
</section>